import { PwaInstallationScenario, PwaNavigator, PwaWindow } from './types';

const iosDevicePattern = /iPad|iPhone|iPod/i;
const safariExcludedBrowserPattern = /Chrome|Chromium|CriOS|Edg|EdgiOS|Firefox|FxiOS|OPR|OPiOS|YaBrowser|YandexSearch/i;

export const isIosOrIpados = (navigatorValue: PwaNavigator): boolean => {
  return iosDevicePattern.test(navigatorValue.userAgent) || (
    navigatorValue.platform === 'MacIntel' && navigatorValue.maxTouchPoints > 1
  );
};

export const isSafari = (navigatorValue: PwaNavigator): boolean => {
  return /Safari/i.test(navigatorValue.userAgent) && !safariExcludedBrowserPattern.test(navigatorValue.userAgent);
};

export const isRunningAsInstalledPwa = (
  navigatorValue: PwaNavigator,
  windowValue: PwaWindow
): boolean => {
  return windowValue.matchMedia('(display-mode: standalone)').matches || navigatorValue.standalone === true;
};

export const getPwaInstallationScenario = (params: {
  hasNativePrompt: boolean;
  isInstalled: boolean;
  navigatorValue: PwaNavigator;
}): PwaInstallationScenario => {
  const {
    hasNativePrompt,
    isInstalled,
    navigatorValue
  } = params;

  if (isInstalled) return 'INSTALLED';
  if (hasNativePrompt) return 'NATIVE';
  if (!isSafari(navigatorValue)) return 'UNAVAILABLE';
  if (isIosOrIpados(navigatorValue)) return 'SAFARI_IOS';

  return /^Mac/i.test(navigatorValue.platform) ? 'SAFARI_MACOS' : 'UNAVAILABLE';
};